export default __webpack_public_path__ + "static/media/competition-announcement.26313ca7.md";